import {useBuscarHelper,} from "../../../Commons/Scripts/Utils/webservice-helper.js";
import {
    URL_GANACIAS_GRAFICO, URL_ITEMS_AUTOCOMPLETE,
    URL_PROMEDIO_ARTICULO_FACTURA_GRAFICO,
    URL_PROMEDIO_VENTA_FACTURA_GRAFICO,
    URL_RENTABILIDAD_POR_ITEM_GRID,
    URL_RENTABILIDAD_POR_VENDEDOR_GRAFICO,
    URL_TARJETAS_DASHBOARD,
    URL_TIENDAS_DATAGRID,
    URL_TIENDAS_GRID,
    URL_TOP10_ITEMS_INGRESO,
    URL_TOP10_ITEMS_VENDIDOS,
    URL_TOP10_OFERTAS_VENDIDAS,
    URL_TOP10_VENDEDORES_COMISION,
    URL_VENTAS_POR_ITEM_GRAFICO,
    URL_VENTAS_TOTALES_GRAFICO
} from '../../../Facturacion/Scripts/Utils/constantes.js'

export const useBuscarTarjetasDashboard = (cuerpo) => {
    const url = URL_TARJETAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};
  };

export const useBuscarPromedioVentaFacturaGrafico = (cuerpo) => {
  const url = URL_PROMEDIO_VENTA_FACTURA_GRAFICO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};
}
export const useBuscarPromedioArticuloFacturaGrafico = (cuerpo) => {
  const url = URL_PROMEDIO_ARTICULO_FACTURA_GRAFICO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};
}
export const useBuscarGananciasGrafico = (cuerpo) => {
  const url = URL_GANACIAS_GRAFICO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};
}
export const useBuscarVentasTotalesGrafico = (cuerpo) => {
  const url = URL_VENTAS_TOTALES_GRAFICO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  return {data, loading, error};
}
export const useBuscarVentasPorItemGrafico = (cuerpo) => {
    const { data, loading, error } = useBuscarHelper(URL_VENTAS_POR_ITEM_GRAFICO, cuerpo);
    return { data, loading, error };
}
export const useBuscarRentabilidadPorVendedorGrafico = (cuerpo) => {
    const { data, loading, error } = useBuscarHelper(URL_RENTABILIDAD_POR_VENDEDOR_GRAFICO,  cuerpo);
    return { data, loading, error };
}
export const useBuscarTops10ItemsVendidos = (cuerpo) => {
  const url = URL_TOP10_ITEMS_VENDIDOS;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  if (cuerpo){
    return {data, loading, error};    
  } else {
    return {data: null, loading: false, error:null}
  }
}
export const useBuscarTops10VendedoresPorComision = (cuerpo) => {
  const url = URL_TOP10_VENDEDORES_COMISION;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  if (cuerpo){
    return {data, loading, error};    
  } else {
    return {data: null, loading: false, error:null}
  }
}
export const useBuscarTops10OfertasVendidasDashboard = (cuerpo) => {
  const url = URL_TOP10_OFERTAS_VENDIDAS;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  if (cuerpo){
    return {data, loading, error};    
  } else {
    return {data: null, loading: false, error:null}
  }
}
export const useBuscarTops10ItemsIngresoDashboard = (cuerpo) => {
  const url = URL_TOP10_ITEMS_INGRESO;
  const { data, loading, error } = useBuscarHelper(url, cuerpo);
  if (cuerpo){
    return {data, loading, error};    
  } else {
    return {data: null, loading: false, error:null}
  }
}
export const useBuscarTiendasAutoComplete = (cuerpo) => {
  const url = URL_TIENDAS_GRID;
  const {data, loading, error} = useBuscarHelper(url, cuerpo);
  return {data, loading, error};
}
export const useBuscarTiendasDataGrid = (cuerpo) => {
  const url = URL_TIENDAS_DATAGRID;
  const {data, loading, error} = useBuscarHelper(url, cuerpo);
  return {data, loading, error};
}

export const useBuscarRentabilidadPorItemdGrid = (cuerpo) => {
    const {data, loading, error} = useBuscarHelper(URL_RENTABILIDAD_POR_ITEM_GRID, cuerpo);
    return {data, loading, error};
}

export const useBuscarItemsAutoComplete = (cuerpo) => {
    const {data, loading, error} = useBuscarHelper(URL_ITEMS_AUTOCOMPLETE, cuerpo);
    return {data, loading, error};
}